import * as React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import assets from "../../assets";
import { Alert, Card, InputAdornment, IconButton, LinearProgress } from '@mui/material';
import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { loginUser } from '../../redux/features/auth/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { unwrapResult } from '@reduxjs/toolkit';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import colorConfigs from '../../configs/colorConfigs';
import versionConfig from '../../configs/versionConfig';
import RareButton from './buttons/RareButton';

function Copyright(props: any) {
  return (
    <Typography data-testid="Typography-ih59" variant="body2" color="text.secondary" align="center" {...props}>
      Premier Biotech OT Scan is registered trademarks of Premier Biotech in many countries of the world.
    </Typography>
  );
};

const SignIn = () => {
  const [isSubmit, setSubmit] = useState(false);
  const [authfailed, setAuthFailed] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false); // New loading state
  const alertContent = "Login failed, please check email and password";
  const dispatch = useDispatch<AppDispatch>();
  const authData = useSelector((state: RootState) => state.auth); // Accessing the auth state

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true); // Start progress indicator
    const data = new FormData(event.currentTarget);
    const username = data.get('email') as string;
    const password = data.get('password') as string;

    try {
      setAuthFailed(false);
      const resultAction = await dispatch(loginUser({ username, password }));
      unwrapResult(resultAction); // If the promise is rejected, this will throw
      setSubmit(true); // Or navigate to another page

    } catch (err) {
      console.error('Failed to login:', err);
      setAuthFailed(true);
    } finally {
      setLoading(false); // Stop progress indicator whether successful or not
    }
  };

  //  Log Auth Data
  React.useEffect(() => {
    console.log(authData);
  }, [authData]);

  return isSubmit === false ? (
    <Box data-testid="Box-tx65"
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        px: 2,
        minWidth: '60vw',
      }}
    >
      {/* Logo at the top */}
      <Box data-testid="Box-lssd"
        component="img"
        sx={{
          width: { xs: '53%', sm: '53%', md: '53%' }, // Responsive widths
          height: 'auto',
          my: 2,
        }}
        alt="Premier Biotech OT Scan Logo"
        src={assets.images.pbiologoexpand}
      />

      {/* Sign‑in card */}
      <Card data-testid="Card-m6rm"
        sx={{
          width: '60%',
          boxShadow: 10,
          p: { xs: 3, sm: 4, md: 5, lg: 8 },
          borderRadius: 5,
        }}
      >
        <CssBaseline />
        {loading && <LinearProgress data-testid="LinearProgress-8wwe" sx={{
          mb: 2,
          backgroundColor: '#fff',
          '& .MuiLinearProgress-bar': {
            backgroundColor: colorConfigs.primary,
          },
        }} />}
        <Box data-testid="Box-ofhc"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box data-testid="Box-eabb" component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            {authfailed ? <Alert data-testid="Alert-cvil" severity="error">{alertContent}</Alert> : null}
            <TextField data-testid="TextField-06rv"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField data-testid="TextField-gtgp"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type={showPassword ? 'text' : 'password'}
              id="password"
              autoComplete="current-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton data-testid="IconButton-3g0v"
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Box data-testid="Box-8bc3"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                my: 2,
              }}
            >
              <RareButton data-testid="RareButton-5k64" type="submit" fullWidth variant="contained" sx={{ width: { xs: '90%', sm: '50%' } }}>
                Sign In
              </RareButton>
            </Box>
            <Box data-testid="Box-lyzc">
              <Link data-testid="Link-p61u" href="/forgot-password" variant="body2">
                Forgot password?
              </Link>
            </Box>
          </Box>
          <Typography data-testid="Typography-4h9p" variant="body2" color="text.secondary" align="center" sx={{ mt: 2 }}>
            {versionConfig.version}
          </Typography>
        </Box>
      </Card>
    </Box>
  ) : (
    <Navigate to="/users" />
  );
};

export default SignIn;
